import * as React from 'react';
import { Input as TextInput, Textarea } from '../../../../components/ui';
import { Select, Switch } from '../../../../components/ui';

import {MediaComponent} from '../../../components/media';
import {TranslateMediaValueToFileProps} from '../../../../utils';
import {LoadingComponent} from '../../../components/LoadingComponent';
import {EnhancedExerciseProps} from './ExerciseForm.map';
import {useExerciseForm} from './ExerciseForm.use-case';
import {Controller} from 'react-hook-form';

// Assuming M is a reference to Materialize global
declare const M: any;

const ExerciseForm = ({
  exercise,
}: {
  exercise: EnhancedExerciseProps;
}): JSX.Element => {
  const _useUseCase = useExerciseForm(exercise);

  const {
    form,
    exerciseValues,
    loading,
    progress,
    recordEnabled,
    exerciseTypeSelected,
    listExerciseType,
    isMediaUploading,
    handleChange,
    handleMediaUpdate,
    handleMediaUploadStatusChange,
    updateExerciseType,
    setRecordEnabled,
    onSubmit,
  } = _useUseCase;

  const {
    register,
    handleSubmit,
    getValues,
    control,
    formState: {errors},
  } = form;

  const renderExerciseTypeOptions = () => {
    return listExerciseType.map((e) => (
      <option value={e.key} key={e.key}>
        {e.label}
      </option>
    ));
  };

  const imageUrl = exercise?.image?.uri || '';
  const videoUrl = exercise?.video?.uri || exercise?.externalVideoUrl || '';

  return (
    <>
      <LoadingComponent loading={loading} progress={progress} />
      <form
        className="form-workout-group-routine"
        onSubmit={handleSubmit(onSubmit)}>
        <div className="row">
          <div className="col s12">
            <div className="card">
              <div className="card-content">
                <div className="row">
                  <div className="col s12">
                    <Controller
                      control={control}
                      name="name"
                      render={({field}) => (
                        <TextInput
                          s={12}
                          {...field}
                          ref={undefined}
                          placeholder="Nome a ser utilizado no exercicio"
                          inputClassName={errors?.name ? 'invalid' : ' '}
                          error={errors?.name?.message as string}
                          label="Nome do exercício*"
                        />
                      )}
                    />
                  </div>
                </div>
                <>
                  <MediaComponent
                    handleMediaUpdate={(mediaType, url) =>
                      handleMediaUpdate(mediaType, url)
                    }
                    control={control}
                    imageUrl={imageUrl?.includes('missing') ? '' : imageUrl}
                    videoUrl={videoUrl?.includes('missing') ? '' : videoUrl}
                    onUploadStatusChange={handleMediaUploadStatusChange}
                  />
                </>
                <div className="row">
                  <div className="col s12">
                    <Controller
                      control={control}
                      name="description"
                      render={({field}) => (
                        <Textarea
                          s={12}
                          {...field}
                          className={errors?.description ? 'invalid' : ' '}
                          placeholder="Adicione uma descrição para o exercicio"
                          error={errors?.description?.message as string}
                          label="Descrição*"
                        />
                      )}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col s6">
                    <label htmlFor="recordEnabled">
                      Habilitar para recordes
                    </label>
                    <Switch
                      offLabel="Off"
                      onLabel="On"
                      id="recordEnabled"
                      checked={recordEnabled}
                      onChange={() => setRecordEnabled(!recordEnabled)}
                    />
                  </div>
                  {recordEnabled && (
                    <div className="col s6">
                      <Select
                        id="exerciseType"
                        value={exerciseTypeSelected}
                        onChange={(e) => updateExerciseType(e.target.value)}
                        label="Tipo de exercício">
                        <option>-</option>
                        {renderExerciseTypeOptions()}
                      </Select>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col s12">
            <button
              className="btn btn-primary"
              type="submit"
              disabled={loading || isMediaUploading}>
              {isMediaUploading ? 'Aguardando upload...' : 'Salvar & continuar'}
            </button>
          </div>
        </div>
      </form>
    </>
  );
};

export default ExerciseForm;
